import ExtensionCapability from '../../capability';
import { Specs } from '@doxyme/extensions-common';

const { AppEvents } = Specs;
type Constraints = Specs.AppEvents.Constraints;
type EventPayload =
  | Specs.AppEvents.ProviderJoinedPayload
  | Specs.AppEvents.ProviderLeftPayload
  | Specs.AppEvents.SessionEndedPayload
  | Specs.AppEvents.LeavePostcallPayload;

/**
 * AppEvents capability allows the app to dispatch events to notify extensions
 * that something happened in the app, such as session lifecycle changes.
 */
export default class AppEventsCapability extends ExtensionCapability<Constraints> {
  static readonly id = AppEvents.id;

  constructor() {
    super(AppEvents);
  }

  send(event: Specs.AppEvents.Events, payload: EventPayload): void {
    for (const instance of Object.values(this.instances)) {
      const events = new Set(this.configsBy(instance).flatMap((c) => c.events));
      if (events.has(event)) {
        instance.notify([event, payload]);
      }
    }
  }
}
